import React from 'react'
import NearMeIcon from '@mui/icons-material/NearMe';
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import ArticleIcon from '@mui/icons-material/Article';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import GoogleIcon from '@mui/icons-material/Google';
import InstagramIcon from '@mui/icons-material/Instagram';
import TelegramIcon from '@mui/icons-material/Telegram';
import { Link } from 'react-router-dom';
function Footer({ bg }) {
  return (
    <footer className={`${bg ? "bg-[#2F2C3D]" : "bg-[#262431]"} py-10 sm:py-20`}>
      <div className='container mx-auto px-5 flex flex-col lg:flex-row items-center lg:items-start justify-center lg:space-x-16 space-y-8 lg:space-y-0'>
        <div className='sm:w-[315px] text-white '>
          <strong className='font-bold sm:mb-5 text-[25px] sm:text-[30px] inline-block'>О компании</strong>
          <p className='text-[13px] sm:text-[15px]'>Общество с ограниченной ответственностью «TSS CENTER» была создана в целях участия в исполнении Постановления Президента Республики Узбекистан №3300 от 29 сентября 2017 года «О мерах по дальнейшему совершенствованию применения контрольно-кассовых машин с фискальной памятью».</p>
        </div>
        <div className='sm:w-[315px] text-white '>
          <strong className='font-bold mb-2 sm:mb-5 text-[25px] sm:text-[30px] inline-block'>Контакты</strong>
          <div className='text-[13px] mb-3 sm:text-[15px] flex  space-x-2'>
            <NearMeIcon className='text-[#00C9DB]' />
            <p>
              Адрес: Республика Узбекистан, г.Ташкент, улица Бабура, дом 69/4
            </p>
          </div>
          <div className='text-[13px] mb-3 sm:text-[15px] flex  space-x-2'>
            <PhoneEnabledIcon className='text-[#00C9DB]' />
            <p>
              24/7 поддержка <a href='tel:712009096'>71 200-90-96</a>
            </p>
          </div>
          <div className='text-[13px] mb-3 sm:text-[15px] flex  space-x-2'>
            <LocationCityIcon className='text-[#00C9DB]' />
            <p>
              Главный офис с 10:00 до 18:00
              тел: <a href='tel:712099060'>71 209 90 60</a> внутренний номер 107, 112, 113
            </p>
          </div>
          <div className='text-[13px] mb-3 sm:text-[15px] flex  space-x-2'>
            <AccountBalanceIcon className='text-[#00C9DB]' />
            <p>

              р/с: 20208000405277010001 в ТГФ АКБ «Капиталбанк»
            </p>
          </div>
          <div className='text-[13px] sm:text-[15px] flex  space-x-2'>
            <ArticleIcon className='text-[#00C9DB]' />
            <p>

              МФО: 00445; ИНН: 307712152; ОКЭД: 95290
            </p>
          </div>
        </div>
        <div className='w-full sm:w-[315px] text-white '>
          <div className='mt-5'>
            <strong className='font-bold mb-2 sm:mb-2 text-[25px] sm:text-[30px] flex justify-center md:justify-start'>Социальные сети</strong>
            <div className='flex flex-wrap items-center justify-center md:justify-start space-x-3'>
              <Link target='_blank' className='w-[48px] mb-2 duration-200 social-link h-[48px] flex items-center justify-center rounded-[50%] bg-white text-black' to={'https://www.google.com/search?q=cashbox&rlz=1C1PASC_enUZ1037UZ1037&oq=cashbox&gs_lcrp=EgZjaHJvbWUqCggAEAAY4wIYgAQyCggAEAAY4wIYgAQyDQgBEC4YrwEYxwEYgAQyBwgCEAAYgAQyBwgDEAAYgAQyBwgEEAAYgAQyBwgFEAAYgAQyBggGEEUYPDIGCAcQRRg80gEIMzcxMGowajGoAgCwAgA&sourceid=chrome&ie=UTF-8'}>
                <GoogleIcon className='social-icon' style={{ "inlineSize": "30px", "blockSize": "30px" }} />
              </Link>
              <Link target='_blank' className='w-[48px] mb-2 duration-200 social-link h-[48px] flex items-center justify-center rounded-[50%] bg-white text-black' to={'https://www.instagram.com/cashbox.uz/'}>
                <InstagramIcon className='social-icon' style={{ "inlineSize": "30px", "blockSize": "30px" }} />
              </Link>
              <Link target='_blank' className='w-[48px] mb-2 duration-200 social-link h-[48px] flex items-center justify-center rounded-[50%] bg-white text-black' to={'https://t.me/cashbox_tss'}>
                <TelegramIcon className='social-icon' style={{ "inlineSize": "30px", "blockSize": "30px" }} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer